import sliderInput from '@/components/mapv2/sliderinput';
import { mapMutations } from 'vuex';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: {}
    },
    globalvalue: {
      type: Boolean,
      default: true
    }
  },
  components: {
    sliderInput
  },
  data() {
    return {
      anchorx: 0.5,
      anchory: 1,
      scale: 0.3,
      style: {}
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val.length > 0) this.commonHandle(val);
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.value).length > 0) {
        this.commonHandle(this.value);
      }
    });
  },
  methods: {
    ...mapMutations(['SET_MAPSTYLEITEM']),
    inputChange(val, type) {
      // 处理可能的事件对象，提取其中的数值
      if (val && val.target) {
        val = Number(val.target.value);
      }
      this.style[type] = val;
      this.style.anchor = [this.anchorx, this.anchory];
      if (type === 'anchorx') this.style.anchor[0] = val;
      if (type === 'anchory') this.style.anchor[1] = val;
      if (!this.globalvalue) {
        this.$emit('data', this.style);
      } else {
        let obj = {};
        obj[this.title] = this.style;
        this.SET_MAPSTYLEITEM(obj);
      }
    },
    commonHandle(val) {
      this.scale = val.scale;
      this.anchorx = val.anchor[0];
      this.anchory = val.anchor[1];
      if (!this.globalvalue) {
        this.style = {
          scale: this.scale,
          anchor: [this.anchorx, this.anchory]
        };
        this.$emit('data', this.style);
      } else {
        let obj = {};
        obj[this.title] = {
          scale: this.scale,
          anchor: [this.anchorx, this.anchory]
        };
        this.SET_MAPSTYLEITEM(obj);
      }
    }
  }
};